import React from 'react';

import { css } from '@emotion/react';

import { palette } from '@lib/styles/palette';

import Icon from '@components/common/Icon';
import { privacyPolicyComponents } from '@components/web/privacy-policy/data/PrivacyPolicyComponents';

interface PrivacyPolicySelectBoxProps {
  onHidePopUp: () => void;
  currentVer: string;
  onClickHandleChangeVer: (version: string) => void;
}
const PrivacyPolicySelectBox = ({
  onHidePopUp,
  currentVer,
  onClickHandleChangeVer,
}: PrivacyPolicySelectBoxProps): JSX.Element => {
  return (
    <div css={wrapper}>
      <div css={bottomModalStyle}>
        <div className="popupTitle">
          <p>시행일자 선택</p>
          <Icon
            icon="close"
            size={24}
            stroke={palette.black10}
            onClick={onHidePopUp}
            className="iconCursorStyle"
          />
        </div>
        <ul css={dateListStyle}>
          {Object.keys(privacyPolicyComponents).map((date) => {
            return (
              <li key={date} css={dateListItemStyle(currentVer === date)}>
                <button
                  type="button"
                  aria-label="termsDate"
                  onClick={() => onClickHandleChangeVer(date)}
                >{`${date} 시행`}</button>
              </li>
            );
          })}
        </ul>
      </div>
    </div>
  );
};

export default PrivacyPolicySelectBox;

const wrapper = css`
  width: 100vw;
  max-width: 750px;
  max-height: 100vh;
  position: relative;
  display: flex;
  align-items: center;

  .iconCursorStyle {
    cursor: pointer;
  }
`;
const bottomModalStyle = css`
  width: 100%;
  max-width: 750px;
  background-color: ${palette.white};
  position: fixed;
  bottom: 0;
  padding: 0 20px;
  background: #ffffff;
  box-shadow: 0px -2px 4px rgba(0, 0, 0, 0.1);

  .popupTitle {
    padding: 12px 0;
    color: ${palette.gray14};
    font-size: 16px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 17px;
    font-weight: 700;
    border-bottom: 1px solid ${palette.gray2};
    color: ${palette.black10};
  }
`;

const dateListStyle = css`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  max-height: 40vh;
  overflow-y: scroll;
  li {
    padding: 12px 0;
    font-size: 16px;
  }

  button {
    background-color: ${palette.white};
  }
`;

const dateListItemStyle = (isActive: boolean) => css`
  font-weight: ${isActive ? '700' : '400'};
  color: ${isActive ? palette.black10 : palette.gray14};
`;
